export default "__VITE_ASSET__DX6NFF5b__"